export default function ScoreGauge({ value, max = 100 }) {
    const clamped = Math.min(Math.max(value, 0), max);
    const progress = clamped / max;

    const radius = 90;
    const stroke = 12;
    const circumference = Math.PI * radius; // half circle

    const dashOffset = circumference * (1 - progress);

    // Calculate tooth position along arc
    const angle = Math.PI * progress; // 0 to PI
    const cx = 120;
    const cy = 120;
    const x = cx - radius * Math.cos(angle);
    const y = cy - radius * Math.sin(angle);

    return (
        <div className="w-full flex justify-center">
            <div className="relative w-[260px] h-[160px] rounded-2xl p-4">
                <svg
                    width="240"
                    height="140"
                    viewBox="0 0 240 140"
                    className="block mx-auto"
                >
                    {/* Background arc */}
                    <path
                        d="M 30 120 A 90 90 0 0 1 210 120"
                        fill="none"
                        stroke="#b3e4fa"
                        strokeWidth={stroke}
                        strokeLinecap="round"
                    />

                    {/* Progress arc */}
                    <path
                        d="M 30 120 A 90 90 0 0 1 210 120"
                        fill="none"
                        stroke="#f391bb"
                        strokeWidth={stroke}
                        strokeLinecap="round"
                        pathLength={circumference}
                        strokeDasharray={circumference}
                        strokeDashoffset={dashOffset}
                    />

                    {/* Tooth marker */}
                    <g transform={`translate(${x}, ${y})`}>
                        <circle r="12" fill="#F06292" />
                        <text
                            x="0"
                            y="5"
                            textAnchor="middle"
                            fontSize="14"
                        >
                            🦷
                        </text>
                    </g>
                </svg>

                {/* Score text */}
                <div className="absolute bottom-4 left-0 right-0 text-center">
                    <span className="text-3xl font-bold text-[#eb509e]">
                        {Math.round(clamped)}
                    </span>
                    <span className="text-lg font-semibold text-signal-ai-blue">
                        /{max}
                    </span>
                </div>
            </div>
        </div>
    );
}